export const PRESCRIBING_INFO_LINKS = {
  spikevax: {
    pi: "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/5efa7d9d-05e8-46b5-945a-637c2867bd00/5efa7d9d-05e8-46b5-945a-637c2867bd00_viewable_rendition__v.pdf",
    info: "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/0822c860-8bfb-4f09-a9b7-2c51d8d10c41/0822c860-8bfb-4f09-a9b7-2c51d8d10c41_viewable_rendition__v.pdf"
  },
  mnexspike: {
    pi: "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/9f00fca4-1dca-4c9e-9bdd-d21a1c0bf5c6/9f00fca4-1dca-4c9e-9bdd-d21a1c0bf5c6_viewable_rendition__v.pdf",
    info: "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/c3adf47f-fb68-4612-b42b-b1a2b0f0b88f/c3adf47f-fb68-4612-b42b-b1a2b0f0b88f_viewable_rendition__v.pdf"
  },
  eua: {
    providers:
      "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/b6653c87-2627-405c-b151-be87db581e7d/b6653c87-2627-405c-b151-be87db581e7d_viewable_rendition__v.pdf",
    recipients:
      "https://static.modernatx.com/pm/6cef78f8-8dad-4fc9-83d5-d2fbb7cff867/7f4a58b0-3467-45be-97e1-7cea1f7f6f03/7f4a58b0-3467-45be-97e1-7cea1f7f6f03_viewable_rendition__v.pdf"
  }
};

export const PRESCRIBING_INFO_KEYS = {
  spikevax: "MDRNA_SPIKEVAX_UPDATE_SHOWN",
  mnexspike: "MDRNA_MNEXSPIKE_UPDATE_SHOWN",
  eua: "MDRNA_SPIKEVAX_EUA_UPDATE_SHOWN"
};
